import React from "react";
import "./css/footer.css";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaFacebookMessenger,
  FaPhoneAlt,
  FaFax,
  FaEnvelope,
  FaHome,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Online Services</h3>
          <ul>
            <li>
              <a href="https://www.mis-mbsmw.org/">
                MBS Management Information System
              </a>
            </li>
            <li>
              <a href="http://192.168.0.5:3002/standardsCatalogue">
                Purchase Malawian Standards
              </a>
            </li>
            <li>
              <a href="https://mbs.isolutions.iso.org/mbs">
                Purchase ISO Standards
              </a>
            </li>
            {/* <li>
              <a href="http://192.168.0.5:3004/">MBS E-Learning</a>
            </li> */}
            <li>
              <a href="http://192.168.0.5:7006/login">Submit Queries</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Milestones</h3>
          <ul>
            <li>
              <p>
                1972: Establishment of the MBS under an Act of Parliament (Cap
                51.02)
              </p>
            </li>
            <li>
              <p>
                1990: Exports Quality certification Scheme (EQCS) is established
              </p>
            </li>
            <li>
              <p>
                1993: Imports Quality Monitoring Scheme (IQMS) is established
              </p>
            </li>
            <li>
              <p>
                1996: Takes over the responsibilities of the implementation of
                the Weights and Measures Act (Cap 48.04) from the Ministry of
                Industry and Trade
              </p>
            </li>
            <li>
              <p>2012: Enactment of the revised MBS Act (Act No. 12 of 2012)</p>
            </li>
            <li>
              <p>
                2016: Commencement of the construction of the new MBS laboratory
                and office complex
              </p>
            </li>
            <li>
              <p>
                2016: Enactment of the new Metrology Act (Act No. 10 of 2016)
                (revision of the Weights and Measures Act)
              </p>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Information Alerts</h3>
          <ul>
            <li>
              <a href="http://192.168.0.5:3002/mediaPublications">
                Press Releases
              </a>
            </li>
            <li>
              <a href="/careers">Job Vacancies</a>
            </li>
            <li>
              <a href="http://192.168.0.5:3002/StandardsUnderPublicReview">
                Draft Standards for Public Review
              </a>
            </li>
            <li>
              <a href="/procurement">Procurement</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Contact Us</h3>

          <p>
            <FaHome className="icon" />
            The Director General
            <br />
            Malawi Bureau of Standards
            <br />
            Ali Hassan Mwinyi Road
            <br />
            P.O Box 946
            <br />
            Blantyre
            <br />
            Malawi
          </p>
          <p>
            <FaPhoneAlt className="icon" /> Tel: +265 1 870 488, +265 891 376 444, +265 891 376 445, +265 891 376 446, +265 891 376 447
          </p>

          <p>
            <FaPhoneAlt className="icon" /> Toll Free Number: 462
          </p>

          {/* <p>
            <FaFax className="icon" /> Fax: +265 1 870 756
          </p> */}
          <p>
            <FaEnvelope className="icon" /> E-mail:{" "}
            <a href="mailto:mbs@mbsmw.org">mbs@mbsmw.org</a>
          </p>

          <div className="separator"></div>
          <div className="social-media">
            <a href="https://www.facebook.com/malawistandardsbureau/">
              <FaFacebookF className="social-icon" />
            </a>
            {/* <a href="https://www.youtube.com/">
              <FaYoutube className="social-icon" />
            </a> */}
            <a href="https://www.linkedin.com/company/malawi-bureau-of-standards/about/">
              <FaLinkedin className="social-icon" />
            </a>
            {/* <a href="https://x.com/MalawiStandards">
              <FaTwitter className="social-icon" />
            </a> */}
            {/* <a href="https://www.instagram.com/">
              <FaInstagram className="social-icon" />
            </a>
            <a href="https://www.facebook.com/malawistandardsbureau/">
              <FaFacebookMessenger className="social-icon" />
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
